export default function(str, reps) {
  var s = '';
  while (--reps >= 0) s += str;
  return s;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-tooltip/node_modules/vega-util/src/repeat.js
// module id = null
// module chunks = 